var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "patsnap-biz-suggestion_board": true,
        "ai-common-suggestion-board": true,
        "ai-common-suggestion-board--default-status": _vm.defaultStatus,
      },
    },
    [
      _c("iframe", {
        staticStyle: {
          top: "0px",
          width: "100%",
          height: "100%",
          display: "block",
          position: "absolute",
          border: "none",
          "z-index": "-100",
        },
        attrs: { src: "" },
      }),
      _c(
        "div",
        { staticClass: "ai-common-suggestion-board__modal" },
        [
          _vm._l(_vm.suggestionList, function (ref) {
            var section = ref.section
            var title = ref.title
            var content = ref.content
            return _c(
              "div",
              { key: section },
              [
                section === _vm.SECTION_TYPE_KEYWORDS
                  ? _c("BlockKeywordQuery", {
                      staticClass: "ai-common-suggestion-board__block",
                      attrs: { items: content, keyword: _vm.stemKeyword },
                      on: { select: _vm.handleSelectKeywordQuery },
                    })
                  : _vm._e(),
                _c(
                  section === _vm.SECTION_TYPE_FIELD
                    ? "BlockFields"
                    : "BlockSuggestion",
                  {
                    tag: "Component",
                    class: {
                      "ai-common-suggestion-board__block": true,
                      "ai-common-suggestion-normal":
                        section !== _vm.SECTION_TYPE_KEYWORDS,
                      "ai-common-suggestion-keywords":
                        section === _vm.SECTION_TYPE_KEYWORDS,
                      "ai-common-suggestion-sample":
                        section === _vm.SECTION_TYPE_SAMPLE,
                    },
                    attrs: {
                      title: title,
                      items: content,
                      "selected-index": _vm.selectedIndex,
                      "on-click": _vm.onClick,
                      "update-selected-index": _vm.updateSelectedIndex,
                    },
                  }
                ),
              ],
              1
            )
          }),
          _c("BlockFields", {
            staticClass:
              "ai-common-suggestion-board__block ai-common-suggestion-board__block--half-width",
            staticStyle: { "padding-right": "40px" },
            attrs: {
              title: _vm.$t("smartSearch.sections.keywordFields"),
              items: _vm.keywordFields,
              "selected-index": _vm.selectedIndex,
              "on-click": _vm.onClick,
              "update-selected-index": _vm.updateSelectedIndex,
            },
          }),
          _c("BlockFields", {
            staticClass:
              "ai-common-suggestion-board__block ai-common-suggestion-board__block--half-width",
            attrs: {
              title: _vm.$t("smartSearch.sections.assigneeFields"),
              items: _vm.assigneeFields,
              "selected-index": _vm.selectedIndex,
              "on-click": _vm.onClick,
              "update-selected-index": _vm.updateSelectedIndex,
            },
          }),
          _c("BlockFields", {
            staticClass:
              "ai-common-suggestion-board__block ai-common-suggestion-board__block--half-width",
            staticStyle: { "padding-right": "40px" },
            attrs: {
              title: _vm.$t("smartSearch.sections.classificationNumberFields"),
              items: _vm.classificationNumberFields,
              "selected-index": _vm.selectedIndex,
              "on-click": _vm.onClick,
              "update-selected-index": _vm.updateSelectedIndex,
            },
          }),
          _c("BlockFields", {
            staticClass:
              "ai-common-suggestion-board__block ai-common-suggestion-board__block--half-width",
            attrs: {
              title: _vm.$t("smartSearch.sections.otherFields"),
              items: _vm.otherFields,
              "selected-index": _vm.selectedIndex,
              "on-click": _vm.onClick,
              "update-selected-index": _vm.updateSelectedIndex,
            },
          }),
          _vm.defaultStatus
            ? _c(
                "div",
                { staticClass: "ai-common-suggestion-board__syntax-helper" },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        mousedown: function ($event) {
                          $event.preventDefault()
                        },
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.goSearchHelper.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("smartSearch.syntaxHelper")))]
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }